/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response after aborting chunk upload.
 * @export
 * @interface ChunksAbortResponse
 */
export interface ChunksAbortResponse {
    /**
     * Abort confirmation message
     * @type {string}
     * @memberof ChunksAbortResponse
     */
    message: string;
}

/**
 * Check if a given object implements the ChunksAbortResponse interface.
 */
export function instanceOfChunksAbortResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ChunksAbortResponseFromJSON(json: any): ChunksAbortResponse {
    return ChunksAbortResponseFromJSONTyped(json, false);
}

export function ChunksAbortResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunksAbortResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function ChunksAbortResponseToJSON(value?: ChunksAbortResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

